import React, { useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { Logo } from "./Logo";

const links = [
  { to: "/atlas", label: "Atlas" },
  { to: "/tools", label: "Tools" },
  { to: "/portfolio", label: "The Labs" },
  { to: "/authoriteos", label: "AuthorityOS" },
  { to: "/shop", label: "Shop" },
  { to: "/blog", label: "Blog" },
  { to: "/work", label: "Work With Us" },
];

export const Nav = () => {
  const [open, setOpen] = useState(false);
  const location = useLocation();

  React.useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  return (
    <nav
      data-testid="main-nav"
      style={{
        position: "sticky",
        top: 0,
        height: 56,
        background: "#090909",
        borderBottom: "1px solid #1a1a1a",
        zIndex: 100,
        display: "flex",
        alignItems: "center",
        padding: "0 20px",
      }}
    >
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%", maxWidth: 1200, margin: "0 auto" }}>
        <Logo />

        {/* Desktop */}
        <div className="tag-nav-desktop" style={{ display: "flex", alignItems: "center", gap: 28 }}>
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              data-testid={`nav-${l.to.replace("/", "")}`}
              style={({ isActive }) => ({
                color: "#fff",
                opacity: isActive ? 1 : 0.85,
                fontSize: 12,
                fontWeight: 500,
                transition: "opacity 0.2s ease",
              })}
            >
              {l.label}
            </NavLink>
          ))}
          <Link to="/portal" data-testid="nav-portal" style={{ color: "#aaa", fontSize: 12, fontWeight: 500 }}>
            Portal
          </Link>
          <Link to="/score" data-testid="nav-cta-score" className="btn-nav-cta">
            Take the Assessment
          </Link>
        </div>

        {/* Mobile burger */}
        <button
          data-testid="mobile-menu-toggle"
          className="tag-nav-mobile-toggle"
          onClick={() => setOpen((v) => !v)}
          style={{
            background: "transparent",
            border: "1px solid #222",
            borderRadius: 8,
            padding: 6,
            color: "#bbb",
            cursor: "pointer",
            display: "none",
          }}
          aria-label="Toggle navigation"
        >
          {open ? <X size={18} /> : <Menu size={18} />}
        </button>
      </div>

      {/* Mobile drawer */}
      {open && (
        <div
          data-testid="mobile-menu"
          style={{
            position: "absolute",
            top: 56,
            left: 0,
            right: 0,
            background: "#0b0b0b",
            borderBottom: "1px solid #1a1a1a",
            padding: "16px 20px",
            display: "flex",
            flexDirection: "column",
            gap: 14,
          }}
        >
          {links.map((l) => (
            <Link
              key={l.to}
              to={l.to}
              data-testid={`mobile-nav-${l.to.replace("/", "")}`}
              style={{ color: "#fff", fontSize: 13, fontWeight: 500 }}
            >
              {l.label}
            </Link>
          ))}
          <Link to="/score" data-testid="mobile-nav-cta-score" className="btn-nav-cta" style={{ alignSelf: "flex-start" }}>
            Take the Assessment
          </Link>
        </div>
      )}

      <style>{`
        @media (max-width: 820px) {
          .tag-nav-desktop { display: none !important; }
          .tag-nav-mobile-toggle { display: inline-flex !important; }
        }
      `}</style>
    </nav>
  );
};
